export default "__VITE_ASSET__CedVALAj__"